import { render, staticRenderFns } from "./FacultyForm.vue?vue&type=template&id=24d2b92a&scoped=true"
import script from "./FacultyForm.vue?vue&type=script&lang=js"
export * from "./FacultyForm.vue?vue&type=script&lang=js"
import style0 from "./FacultyForm.vue?vue&type=style&index=0&id=24d2b92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2b92a",
  null
  
)

export default component.exports